APP.registerBrochure = function () {
	const el = $('.register-brochure');
	const btnXFC = $('.btn--xfc');
	const loading = el.find('.loading');
	const company = el.find('[name="o2o-company"]');
	const selectDealer = el.find('[name="dealer_id"]');
	const selectDealerOption = selectDealer.data('label-dealer');
	const selectDealerInputPlaceholder = selectDealer.data('input-placeholder');
	const slickCarChoose = el.find('.slick--car-choose');
	const tagsModel = el.find('[name="tags_model"]');
	const modelId = el.find('[name="model_id"]');
	const modelName = el.find('[name="model_name"]');
	const position = el.find('[name="position"]');
	const form_type = el.find('[name="form_type"]');
	const selectVariant = el.find('[name="variant_id"]');
	const selectVariantOption = selectVariant.data('label-text');
	const selectVariantInputPlaceholder = selectVariant.data('input-placeholder');
	const textTD = el.find('.text-td');
	const textTDOne = el.find('.text-td--one');
	const textTDTwo = el.find('.text-td--two');

	const thankYou = $('.thank-you');
	const thankYouName = thankYou.find('.thank-you__name');
	const thankYouPrice = thankYou.find('.thank-you__price');
	const thankYouThumb = thankYou.find('.thank-you__thumb img');
	const thankYouUserName = thankYou.find('.thank-you__username');
	const thankYouUserPhone = thankYou.find('.thank-you__userphone');
	const thankYouUserEmail = thankYou.find('.thank-you__useremail');
	const thankYouUserNameTitle = thankYouUserName.data('text-username');
	const thankYouUserPhoneTitle = thankYouUserPhone.data('text-userphone');
	const thankYouUserEmailTitle = thankYouUserEmail.data('text-useremail');

	const thankContact = thankYou.find('.thank-contact');
	const thankContactTitle = thankContact.find('.thank-contact__title');
	const thankContactAddress = thankContact.find('.thank-contact__address');
	const thankContactPhone = thankContact.find('.thank-contact__phone');
	const thankContactPhoneSaleText = thankContactPhone.data('phone-sale');
	const thankContactPhoneServiceText = thankContactPhone.data('phone-service');
	const thankContactWeb = thankContact.find('.thank-contact__web');

	const [getLocation, setLocation] = useLocation();
	const [getDealer, setDealer] = useDealer();
	const [getDealerItems, setDealerItems] = useDealerItems();

	const getLocationBtn = el.find('.dealer-current');
	const getLocationBtnText = getLocationBtn.data('text-nearby');
	const getLocationBtnTextButton = getLocationBtn.data('text-nearby-btn');

	let dataSubmit = {};

	function useLocation() {
		let _location = null;

		function getLocation() {
			return _location;
		}

		function setLocation(data) {
			_location = { ...data };
		}

		return [getLocation, setLocation];
	}

	function useDealer() {
		let _dealer = null;

		function getDealer() {
			return _dealer;
		}

		function setDealer(data) {
			_dealer = [...data];
		}

		return [getDealer, setDealer];
	}

	function useDealerItems() {
		let _dealerItems = null;

		function getDealerItems() {
			return _dealerItems;
		}

		function setDealerItems(data) {
			_dealerItems = data;
		}

		return [getDealerItems, setDealerItems];
	}

	function init() {
		if (el.length === 0) return;

		if ($('.car-choose').length === 0) {
			const mmv_campaign = getParameterByName('mmv_campaign')
				? getParameterByName('mmv_campaign')
				: getCookie('mmv_campaign');

			if (tagsModel.val()) {
				company.val(`${tagsModel.val()}`);
				if (mmv_campaign) {
					company.val(`${tagsModel.val()},${mmv_campaign}`);
				}
			} else if (mmv_campaign) {
				company.val(`${mmv_campaign}`);
			}
		}

		const searchParams = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		if (searchParams.position) {
			position.val(searchParams.position);
			form_type.val(searchParams.position);
		}

		slickCarChoose.slick({
			infinite: true,
			centerMode: true,
			centerPadding: '180px',
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						infinite: true,
						centerMode: true,
						centerPadding: '60px',
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

		slickCarChoose.on('swipe', function () {
			handleCarChoose();
		});

		slickCarChoose.on('afterChange', function () {
			handleCarChoose();
		});

		slickCarChoose.on('click', '.slick-active', onClickSlickItem);

		APP.getDealers(selectDealer, selectDealerOption, selectDealerInputPlaceholder);

		thankYou.hide();

		textTD.hide();
		textTDOne.show();

		btnXFC.on('click', function (evt) {
			evt.preventDefault();
			const obj = $(this);
			const secRegister = obj.attr('href');
			const postionValue = obj.data('position');
			const dealerValue = obj.data('dealer-value');
			const posY = $(secRegister).offset().top;
			APP.setScrollTopAnimation(posY);
			textTD.hide();
			if (postionValue && postionValue !== 'data-position') {
				textTDTwo.show();
				position.val(postionValue);
				form_type.val(postionValue);
			} else {
				textTDOne.show();
				position.val('');
				form_type.val('');
			}
			if (dealerValue && dealerValue !== 'data-dealer-value') {
				selectDealer.val(dealerValue);
				selectDealer.trigger('change');
			}
		});

		APP.validate('.form--test-drive', {
			isAjax: true,
			onComplete: function (res) {
				const selectVariantType = selectVariant.attr('type');
				let variant_name = '';
				const dealer_name =
					selectDealer.find('option:selected').val() === ''
						? ''
						: selectDealer.find('option:selected').text() ||
						  $('[name="model_id"]').data('model-name');
				if (selectVariantType !== 'hidden') {
					variant_name =
						selectVariant.find('option:selected').val() === ''
							? ''
							: selectVariant.find('option:selected').text() || $('[name="variant_name"]').val();
				}

				dataSubmit = {
					utm_source: getParameterByName('utm_source')
						? getParameterByName('utm_source')
						: getCookie('utm_source'),
					utm_content: getParameterByName('utm_content')
						? getParameterByName('utm_content')
						: getCookie('utm_content'),
					utm_medium: getParameterByName('utm_medium')
						? getParameterByName('utm_medium')
						: getCookie('utm_medium'),
					utm_campaign: getParameterByName('utm_campaign')
						? getParameterByName('utm_campaign')
						: getCookie('utm_campaign'),
					mmv_campaign: getParameterByName('mmv_campaign')
						? getParameterByName('mmv_campaign')
						: getCookie('mmv_campaign'),
					form_type: getParameterByName('form_type')
						? getParameterByName('form_type')
						: 'register-brochure',
					location: window.location.href,
					env: getParameterByName('env') ? getParameterByName('env') : 'dev',
				};

				if (form_type.val() !== '') {
					dataSubmit.form_type = form_type.val();
				}

				const data = {
					...res,
					...dataSubmit,
					dealer_name,
					variant_name,
				};
				const dataInput = data;

				loading.show();
				fetch(`${api}/form/testDrive`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						lang: _lang,
					},
					body: JSON.stringify(data),
				})
					.then((res) => res.json())
					.then((data) => {
						loading.hide();

						if (data.result === 'success') {
							thankYouName.html(data.data_variant?.title?.rendered);
							thankYouPrice.html(data.data_variant?.acf?.price_text_has_vat);
							thankYouUserName.html(thankYouUserNameTitle + ' ' + res.name);
							thankYouUserPhone.html(thankYouUserPhoneTitle + ' ' + res.phone);
							thankYouUserEmail.html(thankYouUserEmailTitle + ' ' + res.email);
							if (data.data_variant?.image_large) {
								thankYouThumb.attr('src', data.data_variant?.image_large);
							} else {
								thankYouThumb.attr('src', data.data_model?.acf?.model_image?.model_image_thumbnail);
							}
							thankContactTitle.html(data.data_dealer?.acf?.company_name);
							thankContactAddress.html(data.data_dealer?.acf?.address);

							const thankContactPhoneSaleList = data.data_dealer?.acf?.phone_sales?.map((item) => {
								return `<a href="tel:${item.phone_sale}">${item.phone_sale} (${thankContactPhoneSaleText})</a>`;
							});
							const thankContactPhoneServiceList = data.data_dealer?.acf?.phone_services?.map(
								(item) => {
									return `<a href="tel:${item.phone_service}" target="_blank">${item.phone_service} (${thankContactPhoneServiceText})</a>`;
								}
							);

							const thankContactWebHTML = `<a href="${data.data_dealer?.acf?.website}" target="_blank">${data.data_dealer?.acf?.website}</a>`;

							if (
								data.data_dealer?.acf?.phone_sales.length > 0 ||
								data.data_dealer?.acf?.phone_services.length > 0
							)
								thankContactPhone.html(
									`<i class="icon icon--phone-red"></i> ${thankContactPhoneSaleList} ${thankContactPhoneServiceList}`
								);
							if (data.data_dealer?.acf?.website) {
								thankContactWeb.html(`<i class="icon icon--lap-red"></i> ${thankContactWebHTML}`);
							}

							/// BEGIN Send data to CDP & CRM
							// dataLayer = dataLayer || [];
							let tags = dataInput.tags_model;
							if (dataInput.mmv_campaign) {
								tags += ',' + dataInput.mmv_campaign;
							}

							dataLayer.push({
								event: 'pangoTrack',
								eventAction: 'generate_lead',
								label: '',
								user_data: {
									email_address: dataInput.email,
									phone_number: dataInput.phone,
									address: {
										first_name: dataInput.name,
									},
								},
								cdpData: {
									properties: {
										fullname: dataInput.name,
										email: dataInput.email,
										phone: dataInput.phone,
										listTagsModel: dataInput.tags_model,
										listTagsCampaign: dataInput.mmv_campaign,
										company: company.val(),
										address: dataInput.dealer_name,
										note: dataInput.note,
										position: dataInput.position,
									},
								},
							});
							/// End

							el.addClass(CLASS._blur);
							gsap.set(thankYou, {
								display: 'block',
								alpha: 0,
							});

							gsap.to(thankYou, {
								duration: 0.4,
								alpha: 1,
								onComplete: function () {
									const thankYouPos = thankYou.position().top;
									APP.setScrollTopAnimation(thankYouPos);
								},
							});
							$('.form__error--response').html('');

							$('.btn--register-again').on('click', function (evt) {
								evt.preventDefault();
								const testDriveItemTwo = $('.test-drive__item:nth-child(2)');
								const testDriveItem = $('.test-drive__item');

								const testDriveItemTwoPos =
									slickCarChoose.length > 0
										? testDriveItemTwo.offset().top
										: testDriveItem.offset().top;
								const headerHeight = $('.header').height() || 0;
								const headerNavMoreHeight = $('.nav-more').height() || 0;
								APP.setScrollTopAnimation(testDriveItemTwoPos - headerHeight - headerNavMoreHeight);

								el.removeClass(CLASS._blur);

								setTimeout(() => {
									gsap.set(thankYou, {
										display: 'none',
										alpha: 0,
									});
									thankYouName.html('');
									thankYouPrice.html('');
									thankYouUserName.html('');
									thankYouUserPhone.html('');
									thankYouUserEmail.html('');
									thankYouThumb.attr('src', '');
									thankContactTitle.html('');
									thankContactAddress.html('');
									thankContactPhone.html('');
									thankContactWeb.html('');
								}, 2000);
							});
						} else {
							$('.form__error--response').html(data.errorMessage);
						}
					})
					.catch((err) => {
						loading.hide();
						console.log(err);
					});
			},
		});

		getLocationBtn.on('click', async function (evt) {
			evt.preventDefault();
			await handleInitialLoad();
		});

		navigator.permissions.query({ name: 'geolocation' }).then(async (permissionStatus) => {
			if (permissionStatus.state === 'granted') {
				await handleInitialLoad();
			}
		});
	}

	function onClickSlickItem(e) {
		e.stopPropagation();
		const index = $(this).data('slick-index');
		slickCarChoose.slick('slickGoTo', index);
		handleCarChoose();
	}

	function handleCarChoose() {
		const mmv_campaign = getParameterByName('mmv_campaign')
			? getParameterByName('mmv_campaign')
			: getCookie('mmv_campaign');
		const slickSlide = slickCarChoose.find('.slick-slide');
		const formGroup = slickCarChoose.next();
		const formError = formGroup.find('.form__error');
		const slickActiveCenter = slickCarChoose.find('.slick-active.slick-center');
		const title = slickActiveCenter.find('.title');
		const modelIdValue = parseInt(title.data('model-id'));
		const modelNameValue = title.text();
		const modelTagValue = title.data('model-tag');
		slickSlide.removeClass(CLASS._selected);
		slickActiveCenter.addClass(CLASS._selected);
		formGroup.removeClass(CLASS._error).removeClass(CLASS._focus);
		formError.text('');
		modelId.val(modelIdValue);
		modelName.val(modelNameValue);
		tagsModel.val(modelTagValue);

		if (tagsModel.val()) {
			company.val(`${modelNameValue}`);
			if (mmv_campaign) {
				company.val(`${tagsModel.val()},${mmv_campaign}`);
			}
		} else if (mmv_campaign) {
			company.val(`${mmv_campaign}`);
		}

		APP.getVariants(
			selectVariant,
			selectVariantOption,
			selectVariantInputPlaceholder,
			modelIdValue
		);
	}

	function haversine_distance(mk1, mk2) {
		var R = 3958.8;
		var rlat1 = mk1.lat * (Math.PI / 180);
		var rlat2 = mk2.lat * (Math.PI / 180);
		var difflat = rlat2 - rlat1;
		var difflon = (mk2.lng - mk1.lng) * (Math.PI / 180);

		var d =
			2 *
			R *
			Math.asin(
				Math.sqrt(
					Math.sin(difflat / 2) * Math.sin(difflat / 2) +
						Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
				)
			);
		return d;
	}

	function sortByKey(array, key) {
		return array.sort(function (a, b) {
			const x = a[key];
			const y = b[key];
			return x < y ? -1 : x > y ? 1 : 0;
		});
	}

	async function getData(url) {
		const response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json',
				lang: _lang,
			},
		});

		const res = await response.json();

		return res;
	}

	async function addDistance() {
		const dealers = getDealer();
		const currentLocation = getLocation();
		const curLocation = {
			lat: currentLocation.lat,
			lng: currentLocation.lng,
		};

		if (curLocation.lat !== 0 && curLocation.lng !== 0) {
			dealers.map((dealer) => {
				const posLocation = dealer.acf.dealer_location;
				const distanceKMNew = haversine_distance(curLocation, posLocation);
				if (distanceKMNew) {
					dealer['distance'] = distanceKMNew;
					dealer['distanceValue'] = distanceKMNew;
				}
			});
			const tmpDealers = Object.assign([], getDealer());
			let dealerData = sortByKey(tmpDealers, 'distanceValue');
			const dealerId = dealerData[0].id;
			APP.sortDealers(
				selectDealer,
				selectDealerOption,
				selectDealerInputPlaceholder,
				dealerId,
				dealerData,
				getLocationBtnText,
				getDealerItems()
			);
			setTimeout(() => {
				selectDealer.val(dealerId).trigger('change');
			}, 1000);
		}
	}

	async function renderCurrentLocation() {
		if (getLocation() === null || getLocation().lat === 0 || getLocation().lng === 0) {
			const position = await getLocationCurrent();
			const curLocation = { lat: position.coords.latitude, lng: position.coords.longitude };
			setLocation(curLocation);
			await addDistance();
			getLocationBtn.find('span').text(getLocationBtnTextButton);
		} else {
			await addDistance();
		}
	}

	async function handleInitialLoad() {
		if (getDealer() === null) {
			const data = await getData(`${api}/wp/dealerNetwork`);
			setDealer(data.items);
			setDealerItems(data);
		}
		await renderCurrentLocation();
	}

	function getLocationCurrent() {
		return new Promise(function (resolve, reject) {
			return navigator.geolocation.getCurrentPosition(resolve, reject);
		});
	}

	init();
};
